export const APP_BACKEND_FUNCTION_NAME = 'bedrock-app_backend' as string;
export const APP_BACKEND_URL = 'https://bedrock.matthis.link/' as string;
export const APP_BACKEND_ROLE_ARN =
  'arn:aws:iam::982619301361:role/bedrock-app_backend-role' as string;
export const APP_FRONTEND_CLOUDFRONT_DOMAIN_NAME = 'static.bedrock.matthis.link' as string;
export const CURRENT_ENV = '982619301361' as string;
export const REGION = 'eu-west-3' as string;
export const ACCOUNT_ID = '982619301361' as string;
export const CODE_BUCKET = 'bedrock-code-20241116112324080800000002' as string;
